import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiSellerDiscount } from '@wix/da-papi-types';
import { ModalRoot } from '@wix/da-ds/pkg/modals/base';
import Popover from '@wix/da-ds/pkg/popovers/dsPresets/Popover';
import { formatDollars } from '@wix/da-shared-react/pkg/utils/formatting';
import s from './DiscountsPopup.scss';

interface Props {
  className?: string;
  isOpen?: boolean;
  onRequestClose?: () => void;
  discounts?: PapiSellerDiscount[];
}

const DiscountLineItem: React.FC<{ discount: PapiSellerDiscount }> = ({
  discount,
}) => {
  const { t } = useTranslation();
  if (discount?.amount?.usd) {
    return (
      <span>
        {formatDollars(discount.amount.usd)} {t('common.off')}{' '}
        {t(`paywall.premium.discounts.popup.audience.var.${discount.audience}`)}
      </span>
    );
  }
  if (discount?.amount?.percent) {
    return (
      <span>
        {discount.amount.percent}% {t('common.off')}{' '}
        {t(`paywall.premium.discounts.popup.audience.var.${discount.audience}`)}
      </span>
    );
  }
};

const DiscountsPopup: React.FC<Props> = ({
  isOpen = false,
  onRequestClose,
  discounts,
}) => {
  const { t } = useTranslation();
  return (
    <ModalRoot className={s['root']} isOpen={isOpen} hasCloseButton={false}>
      <Popover
        className={s['popover']}
        heading={t('paywall.premium.discounts.popup.title')}
        content={
          <div className={s['content']}>
            <ul className={s['list']}>
              {discounts?.map(discount => (
                <li key={discount.discountId} className={s['list-item']}>
                  <DiscountLineItem discount={discount} />
                </li>
              ))}
            </ul>
          </div>
        }
        onCloseClick={onRequestClose}
      />
    </ModalRoot>
  );
};
DiscountsPopup.displayName = 'DiscountsPopup';

export default DiscountsPopup;
